import classnames from 'classnames'
import { NextPage } from 'next'
import GenreComponent from '../components/GenreComponent'
import { GENRES_LIST_QUERY } from '../../../gql'
import { staticProps } from '../../../utils/createApolloClient'
import PlaylistsLayout from '../components/PlaylistsLayout'

import styles from '../_playlistsPage.module.scss'
import { Genre } from '../../../__generated__/graphql'

const genresList = (genres) => {
  return genres.map((genre) => {
    return (
      <div
        key={genre.id}
        className={classnames(
          styles.artistItem,
          'column is-half-mobile is-half-tablet is-one-third-desktop is-one-third-widescreen'
        )}
      >
        <GenreComponent genre={genre} mode={'full'} />
      </div>
    )
  })
}
const GenresPlaylistsPage: NextPage<{
  genres: Genre[]
}> = ({ genres }) => {
  return (
    <PlaylistsLayout>
      <div className={`columns is-variable is-multiline is-mobile is-3-fullhd`}>
        {genresList(genres)}
      </div>
    </PlaylistsLayout>
  )
}

export const getStaticProps = staticProps({
  additionalProps: async ({ client }) => {
    const {
      data: { staticData }
    } = await client.query({
      query: GENRES_LIST_QUERY
    })

    return {
      genres: staticData.genres
    }
  }
})

export default GenresPlaylistsPage
